import { convertTimeColon, getDayOfWeek } from '../dateTimeUtils'
import CourierMessaging from './CourierMessaging'

export default class DHLPickupMessaging implements CourierMessaging {
    constructor(
        private messages: any,
        private pickupLatest: string,
        private currentDateTime: Date,
        private plannedPickupDateAndTime: Date
    ) {}

    private formatPickupTime(): string {
        return this.currentDateTime.toString() === this.plannedPickupDateAndTime.toString()
            ? this.messages.createCollection.timeSlot.now()
            : `${this.plannedPickupDateAndTime.getHours()}:${String(this.plannedPickupDateAndTime.getMinutes()).padStart(2, '0')}`
    }

    formatTimePeriod(): string {
        const pickupTime = this.formatPickupTime()
        const pickupLatest = convertTimeColon(this.pickupLatest);
        return this.messages.createCollection.timeSlot.betweenTimeSlot({
            pickupTime, pickupLatest
        })
    }

    formatDatePeriod(): string {
        const currentDate = this.currentDateTime.getDate()
        const plannedDate = this.plannedPickupDateAndTime.getDate()
        const day = this.plannedPickupDateAndTime.getDay()
        return getDayOfWeek(currentDate, plannedDate, day, this.messages)
    }
}